var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Lock = function Lock(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 10V7a5 5 0 1 1 10 0v3a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3Zm2.879-5.121A3 3 0 0 1 15 7v3H9V7a3 3 0 0 1 .879-2.121ZM10 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Lock;